import React, { useContext } from 'react';
import styled from 'styled-components';
import Layout from '~/components/layout/_layout';
import SEO from '~/components/seo';
import { Trans, withI18n } from '@lingui/react';
import FAQ from '~/components/faq/FAQ';
import { ContentWrapper, SectionContainer } from '~/styles/common';
import { paths } from '../../shared/routing';
import { getPath } from '../../shared/utils';
import { LangContext } from '~/providers/LangProvider';
import Link from '~/components/link';
import { t } from '@lingui/macro';
import { faqBusiness } from '../../src/catalog/faq-business.ts';

/**
 * Frequently asked questions by our merchants
 */
function FaqMerchantPage() {
    const ctx = useContext(LangContext);

    const country = ctx.state.country;

    const faqBusinessLink = getPath(paths.faq, country);
    const faqPersonaLink = getPath(paths.faq_customer, country);

    return (
        <Layout>
            <SEO
                title={t`page.faq.seo.title`}
                ogImage={t`faq.og-image`}
                description={t`page.faq.seo.description`}
            />
            <FaqSectionContainer>
                <ContentWrapper>
                    <Heading>
                        <Trans id="global.menu.link.faq" />
                    </Heading>
                    <Switcher>
                        <StyledLink href={faqBusinessLink}>
                            <Option className={'active'}>
                                <Trans id="faq.merchant.heading" />
                            </Option>
                        </StyledLink>
                        <StyledLink href={faqPersonaLink}>
                            <Option>
                                <Trans id="faq.customer.heading" />
                            </Option>
                        </StyledLink>
                    </Switcher>
                    <FAQ FAQitems={faqBusiness} />
                </ContentWrapper>
            </FaqSectionContainer>
        </Layout>
    );
}

export default withI18n()(FaqMerchantPage);

const StyledLink = styled(Link)`
    text-decoration: none !important;
`;

const Heading = styled.div`
    font-weight: bold;
    font-size: 2.5rem;
    text-align: center;
    letter-spacing: -1px;
    color: #0cc8a8;
`;

const Switcher = styled.div`
    display: flex;
    margin-bottom: 32px;
    margin-top: 30px;
`;

const Option = styled.div`
    cursor: pointer;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    letter-spacing: 0.6px;
    color: #c1c1c1;

    &.active {
        color: #21c298;
        border-bottom: 3px solid #21c298;
    }

    &:last-child {
        margin: 0 20px;
    }
`;

const FaqSectionContainer = styled(SectionContainer)`
    padding-top: 30px;
    background: white;
`;
